module.exports = __webpack_public_path__ + "static/RobotoMono-Regular-e5ca8c0ac474df46fe45840707a0c483.ttf";